import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable, Subject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Installer} from '../models/installer.interface';

@Injectable({
	providedIn: 'root'
})
export class InstallerService {
	baseUrl: string = `${environment.url}/installer`;
	installerSubject: Subject<Installer[]> = new Subject<Installer[]>();
	constructor(private http: HttpClient) {}

	create(installer: FormData): Observable<Installer> {
		return this.http.post<Installer>(this.baseUrl, installer);
	}

	findAll(): void {
		this.http.get<Installer[]>(this.baseUrl).subscribe((response) => {
			this.installerSubject.next(response);
		});
	}

	findOne(id: number): Observable<Installer> {
		return this.http.get<Installer>(`${this.baseUrl}/${id}`);
	}

	update(installer: FormData, id: number): Observable<Installer> {
		return this.http.put<Installer>(`${this.baseUrl}/${id}`, installer);
	}

	remove(id: number): Observable<void> {
		return this.http.delete<void>(`${this.baseUrl}/${id}`);
	}

	findAttachment(installerId: number, fileHash: string): Observable<any> {
		return this.http.get<any>(`${this.baseUrl}/${installerId}/attachment/${fileHash}`);
	}
}
